import * as React from 'react';
import { getHubEnabled, getHubConnectedOnce } from 'pages/views/devices/utils/storage';
import { OpenHub } from './OpenHub';
import { ManageHub } from './ManageHub';

const DevicesSidebar = () => {
  const isHubEnabled = getHubEnabled();
  const hasHubConnectedOnce = getHubConnectedOnce();

  if (!isHubEnabled && !hasHubConnectedOnce) return <OpenHub />;

  return <ManageHub />;
};

export { DevicesSidebar };
